module.exports = __webpack_public_path__ + "img/cakc.e9ada1e5.jpg";